import { lazy, Suspense } from "react";
import { SiteEnhancer } from "@/site/SiteEnhancer";
import { BookingModal } from "@/site/BookingModal";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

export default function App() {
  if (window.location.pathname.startsWith("/admin")) {
    return (
      <Suspense fallback={null}>
        <AdminApp />
      </Suspense>
    );
  }
  return (
    <>
      <SiteEnhancer />
      <BookingModal />
    </>
  );
}
